//Please keep this file as short and simple as possible by creating React Components and implementing program logic within them

import LoadingComponent from "./pages/Shared/LoadingComponent/LoadingComponent.js";
import RoutingComponent from "./pages/Shared/Routing/RoutingComponent.js"
import ThemeComponent from "./pages/Shared/Theme/ThemeComponent.js";
import { getTheme } from "./pages/Shared/Theme/getTheme.js";
import { ThemeProvider } from "@mui/material";

export default function App() {
  let theme = getTheme()
  return (
    <ThemeProvider theme={theme} defaultMode="dark">
      <ThemeComponent>
        <LoadingComponent>
          <RoutingComponent />
        </LoadingComponent>
      </ThemeComponent>
    </ThemeProvider>
  );
}